var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8889 5.03834L10.0533 5.87389L11.5822 7.40871H5.55556V8.59389H11.5822L10.0533 10.1228L10.8889 10.9643L13.8519 8.0013L10.8889 5.03834ZM3.18519 3.85315H7.92593V2.66797H3.18519C2.53333 2.66797 2 3.2013 2 3.85315V12.1495C2 12.8013 2.53333 13.3346 3.18519 13.3346H7.92593V12.1495H3.18519V3.85315Z",
    fill: "#FF5000"
  })));
};
export default SvgLogout;